var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05772 7L15.3238 19.1341L6 29H8.09902L16.2628 20.3627L22.8583 29H30L20.213 16.1833L28.8921 7H26.793L19.2754 14.9547L13.2008 7H6.05912H6.05772ZM9.14359 8.51401H12.4237L26.9113 27.486H23.6312L9.14359 8.51401Z",
    fill: "#100A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterx);
export default __webpack_public_path__ + "static/media/twitterx.a662a4f7d340e1346236c7aea08faac7.svg";
export { ForwardRef as ReactComponent };